module.exports = __webpack_public_path__ + "img/trash-icon-black.dbf8101b.svg";